export const BOAT_DETAILS_STEP = 0.125;
export const DEFAULT_MAP_LAT = 25.8805255;
export const DEFAULT_MAP_LNG = -80.2533466;

export const boatUsPhoneNumber = '1-877-970-BOAT (2628)';
export const buoyPhoneNumber = '(510) 426-5961';

export const captainSeparateText =
  'Since you are providing the list of captains, you are responsible for coordinating how renters pay them directly.';
